export const counterText = {
    textAlign: "right",
    color: "red"
};
